module.exports = __webpack_public_path__ + "static/media/model-export.daedc9f9.png";